import RelationshipMetadata from "../../RelationshipMetadata";

class WorkGroupWorkGroupOrganizationRelationshipMetadata extends RelationshipMetadata {
    constructor() {
        super();

        this.name = "WorkGroupWorkGroupOrganizationRelationshipMetadata";
        this.parentEnterpriseComponent = "WorkGroup";
        this.childEnterpriseComponent = "WorkGroupOrganization";
        this.sourceAttribute = "USID";
        this.destinationAttribute = "WorkGroupUSID";
    }
}

export default WorkGroupWorkGroupOrganizationRelationshipMetadata;